export default function loadLocale(locale) {
      return null;
}
